import "./MiddleSection.css";

export default function MiddleSection() {
  return (
    <section className="middle-section">
      <div className="overlay">
        <h1 className="vision-text">
          Empowering healthcare workers to connect globally, gather insights, and transform measurements into life-changing solutions.
        </h1>
        <a href="https://medimetrics-patient-web.vercel.app/"><button className="learn-more-btn">Get Started</button></a>
      </div>
    </section>
  );
}
